/* @flow */

export default {
  root: {
    position: 'fixed',
    left: 0,
    top: 0,

    width: '100%',
    height: '100%',

    backgroundPosition: 'center center',
    backgroundSize: 'cover',
  },
};
